import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { TimeOffPage } from "@/features/timeoff/TimeOffPage";

const search = z.object({
  month: z.string().regex(/^\d{4}-\d{2}$/).optional(),
  country: z.string().length(2).optional(),
});

export const Route = createFileRoute("/_app/time-off/")({
  validateSearch: search,
  component: () => <TimeOffPage search={Route.useSearch()} />,
});
